import React from 'react';
import { SearchIcon, BellIcon } from 'lucide-react';
import { ProfileDropdown } from './ProfileDropdown';
export const TopBar = () => {
  return <div className="h-16 bg-[#22252A] border-b border-gray-700 flex items-center justify-between px-6" data-id="element-213">
      <div className="flex-1 max-w-xl" data-id="element-214">
        <div className="relative" data-id="element-215">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-216" />
          <input type="text" placeholder="Search events, artists, teams..." className="w-full bg-[#2C2F33] text-[#F5F5F7] rounded-lg pl-10 pr-4 py-2 border border-gray-700 focus:border-[#007BFF] focus:outline-none" data-id="element-217" />
        </div>
      </div>
      <div className="flex items-center" data-id="element-218">
        <button className="relative p-2 mr-4 text-[#F5F5F7] hover:bg-[#2C2F33] rounded-lg" data-id="element-219">
          <BellIcon size={20} data-id="element-220" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-[#007BFF] rounded-full" data-id="element-221"></span>
        </button>
        <ProfileDropdown userName="John Doe" userEmail="john.doe@example.com" userPlan="Casual User" data-id="element-222" />
      </div>
    </div>;
};